var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-framework";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { LotteryBrandDiscountModel } from "../../../../../models/modules/lotteryplatofrm.models";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
import * as Enumerable from "linq";
var LotteryTicketDiscounts = /** @class */ (function (_super) {
    __extends(LotteryTicketDiscounts, _super);
    function LotteryTicketDiscounts(notificationService, i18N, dialogClientService, lotteryClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.dialogClientService = dialogClientService;
        _this.lotteryClientService = lotteryClientService;
        _this.numberOfDraws = null;
        return _this;
    }
    LotteryTicketDiscounts.prototype.addDiscount = function () {
        var model = new LotteryBrandDiscountModel();
        model.chanceOfWinning = 0;
        model.numberOfDraws = this.lotteryPricingModel.lotteryBrandDiscounts.length == 0 ? 1 : Enumerable.from(this.lotteryPricingModel.lotteryBrandDiscounts).lastOrDefault().numberOfDraws + 1;
        model.discount = this.lotteryPricingModel.lotteryBrandDiscounts.length == 0 ? 0 : Enumerable.from(this.lotteryPricingModel.lotteryBrandDiscounts).lastOrDefault().discount;
        model.countryId = null;
        model.subscriptionMonths = null;
        model.promotionalTitle = "";
        model.isMonthlySubscription = false;
        model.isBestValue = false;
        model.isDefault = false;
        this.lotteryPricingModel.lotteryBrandDiscounts.push(model);
    };
    LotteryTicketDiscounts.prototype.onActivated = function (item) {
        var _this = this;
        this.lotteryPricingModel = item.lotteryPricingModels[0];
        if (item.lotteryId && item.lotteryId != 0) {
            this.lotteryClientService.getLotteryDrawsInMonth(item.lotteryId)
                .then(function (x) { return _this.numberOfDraws = x; });
        }
    };
    LotteryTicketDiscounts.prototype.calculateDraws = function (lotteryBrandDiscountItem) {
        lotteryBrandDiscountItem.numberOfDraws = lotteryBrandDiscountItem.subscriptionMonths ? (lotteryBrandDiscountItem.subscriptionMonths * this.numberOfDraws) : 0;
    };
    LotteryTicketDiscounts.prototype.removeDiscount = function (lotteryBrandDiscountItem) {
        var index = this.lotteryPricingModel.lotteryBrandDiscounts.indexOf(lotteryBrandDiscountItem);
        this.lotteryPricingModel.lotteryBrandDiscounts.splice(index, 1);
    };
    LotteryTicketDiscounts.prototype.isReadonly = function () {
        if (!this.lotteryPricingModel || !this.item || !this.item.navigationInfo)
            return true;
        return this.item.navigationInfo.brandId && this.item.navigationInfo.brandId != this.lotteryPricingModel.brandId;
    };
    LotteryTicketDiscounts = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, DialogClientService,
            LotteryClientService])
    ], LotteryTicketDiscounts);
    return LotteryTicketDiscounts;
}(ChildComponent));
export { LotteryTicketDiscounts };
